import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import './InputField.component.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function InputFieldComponent({
  input,
  label,
  type,
  enterFunc,
  propsId,
  meta: { touched, error },
  errorTrigger,
}: any) {
  const [trigger, setTrigger] = useState(false);
  useEffect(() => setTrigger(errorTrigger), [errorTrigger]);
  return (
    <div className='field-container'>
      <input
        {...input}
        id={!!propsId ? propsId : null}
        placeholder={label}
        type={type}
        autoComplete={false}
        className={
          'field ' +
          ((touched || trigger) && error
            ? 'field-error'
            : touched
            ? 'field-success'
            : '')
        }
        onKeyDown={(e: any) => {
          if (e.key === 'Enter' && !!enterFunc) {
            e.preventDefault();
            if (!!error) {
              return;
            }
            if (!!input.value.trim().length) {
              enterFunc(input.value);
            }
          }
        }}
      />
      {!!enterFunc && (
        <button
          className='btn input-button'
          onClick={(e: any) => {
            e.preventDefault();
            if (!!error) {
              return;
            }
            if (!!input.value.trim().length) {
              enterFunc(input.value);
            }
          }}
        >
          <FontAwesomeIcon icon='plus-circle' className='add-icon' />
        </button>
      )}
      <div className='message-container'>
        {(touched || trigger) && error && (
          <span className='field-error-message'>
            <FormattedMessage id={error.id} values={{ value: error.value }} />
          </span>
        )}
      </div>
    </div>
  );
}
